export const SALON_ROLE_OPTIONS = [
  "admin",
  "owner",
  "manager",
  "receptionist",
  "technician",
  "apprentice",
  "independent_professional",
];

export function normalizeSalonRole(role) {
  if (!role && role !== 0) {
    return "technician";
  }
  const normalized = String(role).trim().toLowerCase();
  if (!normalized) {
    return "technician";
  }
  if (normalized === "reception" || normalized === "front desk" || normalized === "front_desk") {
    return "receptionist";
  }
  if (SALON_ROLE_OPTIONS.includes(normalized)) {
    return normalized;
  }
  return "technician";
}

const ROLE_LABELS = {
  admin: "Admin",
  owner: "Owner",
  manager: "Manager",
  receptionist: "Receptionist",
  technician: "Technician",
  apprentice: "Apprentice",
  independent_professional: "Independent Professional",
};

export function roleLabel(role) {
  const canonical = normalizeSalonRole(role);
  return ROLE_LABELS[canonical] || ROLE_LABELS.technician;
}

export function isSalonOwnerOrManager(role) {
  const canonical = normalizeSalonRole(role);
  return (
    canonical === "owner" ||
    canonical === "admin" ||
    canonical === "manager" ||
    canonical === "independent_professional"
  );
}

export function isOwnerOrSuperAdmin(role, isSuperAdmin) {
  if (Boolean(isSuperAdmin)) return true;
  const canonical = normalizeSalonRole(role);
  return canonical === "owner" || canonical === "admin";
}
